import { inject } from '@angular/core';
import {
  CanActivateFn,
  Router,
  type MaybeAsync,
  type GuardResult,
} from '@angular/router';
import { AuthManager } from '@infra-adapters/services/auth.service';
import { UserRole } from '@core-interfaces/global';

export const RoleGuard: CanActivateFn = (
  route,
  state
): MaybeAsync<GuardResult> => {
  const authService = inject(AuthManager);
  const router = inject(Router);
  
  if (!authService.isAuth()) {
    return router.createUrlTree(['/login']);
  }
  
  const userData = authService.UserSessionData();
  if (!userData) {
    return router.createUrlTree(['/login']);
  }
  
  // Get allowed roles from route data
  const allowedRoles = route.data['roles'] as UserRole[] | undefined;
  
  // If no roles specified, allow all authenticated users
  if (!allowedRoles || allowedRoles.length === 0) {
    return true;
  }
  
  // Check if user's role is in the allowed roles
  if (allowedRoles.includes(userData.role)) {
    return true;
  }
  
  // User doesn't have permission, redirect to default page
  return router.createUrlTree(['/request']);
};
